
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";
import { UserModel } from "@/types/interfaces";

export default defineComponent({
  name: "GroupMembers",

  computed: {
    ...mapState(["currentGroup", "loadedUsersFromGroup"]),
  },

  methods: {
    ...mapActions(["getGroupById", "getUserById", "deleteLoadedUsers"]),
  },

  // eslint-disable-next-line consistent-return
  async mounted() {
    try {
      await this.getGroupById(this.$route.params.id);
      const groupMembers = this.currentGroup.members;
      await groupMembers.forEach((member: UserModel) => this.getUserById(member));
      this.deleteLoadedUsers();
    } catch {
      return false;
    }
  },
});
